import { Paper } from "helpers/api";
import { useAppSelector } from "hooks/useStore";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  removePaper,
  removeQuote,
  selectIsPaperSidebarDrawerActive,
  selectPaperSidebarDrawerInteractionId,
  selectSearchStepDrawerPaper,
  selectPaperSidebarDrawerQuote,
  setPaper,
  setQuote,
} from "store/slices/rightSidebarDrawer";

export default function usePaperSidebarDrawer() {
  const dispatch = useDispatch();
  const paper = useAppSelector(selectSearchStepDrawerPaper);
  const quote = useAppSelector(selectPaperSidebarDrawerQuote);

  const interactionId = useAppSelector(selectPaperSidebarDrawerInteractionId);
  const isActive = useAppSelector(selectIsPaperSidebarDrawerActive);

  const closePaperSidebarDrawer = useCallback(() => {
    dispatch(removePaper());
    dispatch(removeQuote());
  }, [dispatch]);

  const openPaperSidebarDrawer = useCallback(
    (paper: Paper, interactionId: string, quote?: string) => {
      dispatch(setPaper({ paper, interactionId }));
      dispatch(setQuote(quote ?? null));
    },
    [dispatch]
  );

  return {
    paper,
    quote,
    interactionId,
    isOpen: !!paper,
    isActive,
    closePaperSidebarDrawer,
    openPaperSidebarDrawer,
  };
}
